const addSelected = (item) => item?.classList.add('selected');
const addAllSelected = (item) => item?.classList.add('selected', 'all-selected');
const addLastSelected = (item) => item?.classList.add('selected', 'all-selected', 'all-selected-last');
const addPrevious = (item) => item?.classList.add('previous')
const removeSelected = (item) => item?.classList.remove('selected', 'all-selected', 'all-selected-last');


const progressOption = (progressStatus = 1) => {
    const progressBarOptions = document.getElementsByClassName('progress-option');
    const numberOfOptions = progressBarOptions.length;

    [].forEach.call(progressBarOptions, function (item, idx) {
        // console.log(item)
        if (!item || item.classList === null) {
            return;
        }

        if (progressStatus === 1) {
            if (idx === 0) {
                addSelected(item)
                return;
            }
        }

        if (progressStatus === 2) {
            if (idx === 0) {
                addAllSelected(item);
                return;
            }

            if (idx === 1 && idx !== numberOfOptions - 1) {
                // want to remove the selected style off the previous element and
                // add the previous background as there is more than two items to render
                removeSelected(progressBarOptions[idx - 1])
                addPrevious(progressBarOptions[idx - 1])

                // add the selected style to the current item
                addSelected(item)
                return;
            }

            if (idx === 1) {
                addLastSelected(item);
                return;
            }
        }

        if (progressStatus === 3) {
            if (idx === 0) {
                addAllSelected(item);
                return;
            }

            if (idx === 1) {
                addAllSelected(item);
                return;
            }

            if (idx === 2 && idx !== numberOfOptions - 1) {
                addSelected(item);
                return;
            }

            if (idx === 2) {
                addLastSelected(item);
            }
        }
    })
}

export default progressOption;
